import { Box, Button, Modal, SpaceBetween } from '@amzn/awsui-components-react';

import { constants } from '../../../common/Localization';
import { format } from '../../../common/util';
import { emailNotificationUrl } from './constants';

interface Props {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    emails: string[];
}
function DataCollectionEmailNotificationModal({ visible, setVisible, emails }: Props): JSX.Element {

    const dismissModal = (): void => setVisible(false);

    const sendQuestionnaireNotification = () => {
        const body = format(constants.EMAIL_BODY, [emailNotificationUrl]);
        const subject = constants.EMAIL_SUBJECT;
        const emailList = emails.join(',');
        const mailto = 'mailto:?bcc=' + emailList + '&subject=' + subject + '&body=' + body;
        
        window.open(encodeURI(mailto));
    };

    const footer = (
        <Box float='right'>
            <SpaceBetween size='s' direction='horizontal'>
                <Button variant='link' onClick={dismissModal}>{constants.CLOSE_BUTTON_TEXT}</Button>
                <Button variant='primary' onClick={sendQuestionnaireNotification}>{constants.SEND_BUTTON_TEXT}</Button>
            </SpaceBetween>
        </Box>
    );

    return (
        <Modal
            header={constants.SEND_QUESTIONNAIRE_EMAIL_HEADER}
            footer={footer}
            visible={visible}
            onDismiss={dismissModal}
        >
            <Box>
                {constants.SEND_QUESTIONNAIRE_EMAIL_MSG1} <br />
                {constants.SEND_QUESTIONNAIRE_EMAIL_MSG2} <a href={emailNotificationUrl}>{emailNotificationUrl}</a><br />
                {constants.SEND_QUESTIONNAIRE_EMAIL_MSG3}
            </Box>
        </Modal>
    );
}

export default DataCollectionEmailNotificationModal;
